module.exports = __webpack_public_path__ + "img/sharegroupicon.b30eb879.svg";